module.exports = __webpack_public_path__ + "static/img/miki.3038f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/miki.png
// module id = WYf9
// module chunks = 3